import { render } from "./MyInstallationAssignments.vue?vue&type=template&id=2f3c0c0c&scoped=true"
import script from "./MyInstallationAssignments.vue?vue&type=script&lang=js"
export * from "./MyInstallationAssignments.vue?vue&type=script&lang=js"

import "./MyInstallationAssignments.vue?vue&type=style&index=0&id=2f3c0c0c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3c0c0c"]])

export default __exports__